export default __webpack_public_path__ + "static/whatsapp-bg-light-187d288165e9b369e3572d3f745bdab3.png";